/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SuccessDelete = {
    properties: {
        success_id: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
